export function getdata() {
	var obj = {
		searchlist: [{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "companySubjectCode",
				label: '公司科目编码',
				type: "input"
			},
			{
				prop: "companySubjectName",
				label: '公司科目名称',
				type: "input"
			},
			{
				prop: "yewkmCode",
				label: '业务科目编码',
				type: "input"
			},
			{
				prop: "yewkmName",
				label: '业务科目名称',
				type: "input"
			},
			{
				prop: "startBalanceDebit",
				label: '期初余额（借方）',
				type: "inputplus"
			},
			{
				prop: "startBalanceCredit",
				label: '期初余额（贷方）',
				type: "inputplus"
			},
			{
				prop: "currentBalanceDebit",
				label: '本期发生额（借方）',
				type: "inputplus"
			},
			{
				prop: "endBalanceDebit",
				label: '期末发生额（借方）',
				type: "inputplus"
			},
			{
				prop: "period",
				label: '税款所属期间',
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				prop: "batchNo",
				label: '批次号',
				type: "input"
			},
		],
		searchdata: {
			companyCode: "",
			companySubjectCode: "",
			companySubjectName: "",
			yewkmCode: "",
			yewkmName: "",
			startBalanceDebit: [],
			startBalanceCredit: [],
			currentBalanceDebit: [],
			endBalanceDebit: [],
			period: "",
			batchNo: "",
			ids: "",
		},
		headData: [{
				title: "公司代码",
				prop: "companyCode",
				width: "80",
				custom: true

			},
			{
				title: "税款所属期间",
				prop: "period",
				width: "110",
				custom: true
			},
			{
				title: "公司科目编码",
				custom: true,
				prop: "companySubjectCode",
				width: 110,
			},
			{
				custom: true,
				title: "公司科目名称",
				prop: "companySubjectName",
				width: 110,
			},
			{
				custom: true,
				title: "业务科目编码",
				prop: "yewkmCode",
				width: 110,
			},
			{
				title: "业务科目名称",
				custom: true,
				prop: "yewkmName",
				width: 110,
			},
			{
				title: "期初余额",
				width: "160",
				children: [{
						title: "借方",
						width: "80",
				custom: true,
				AmountFormat: true,
						prop: "startBalanceDebit"
					},
					{
						title: "贷方",
				custom: true,
				width: "80",
						AmountFormat: true,
						prop: "startBalanceCredit"
					}
				]
			},
			{
				title: "本期发生额",
				width: "160",
				children: [{
						title: "借方",
				custom: true,
				width: "80",
						AmountFormat: true,
						prop: "currentBalanceDebit"
					},
					{
				custom: true,
				title: "贷方",
						width: "80",
						AmountFormat: true,
						prop: "currentBalanceCredit"
					}
				]
			},
			{
				title: "期末余额",
				width: "160",
				children: [{
						title: "借方",
				custom: true,
				width: "80",
						AmountFormat: true,
						prop: "endBalanceDebit"
					},
					{
						title: "贷方",
						width: "80",
				custom: true,
				AmountFormat: true,
						prop: "endBalanceCredit"
					}
				]
			},
			{
				title: "批次号",
				custom: true,
				prop: "batchNo",
				width: 100,
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
